import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Trash, Printer, CardChecklist, ListCheck, PencilFill } from 'react-bootstrap-icons';
import moment from 'moment';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import { jsPDF } from 'jspdf';
import XLSX from 'sheetjs-style';
import 'jspdf-autotable';
import 'assets/css/table.css';
import dateformat from 'dateformat';

import common from '../../../commonData';
import NavMenu from './navbar';
import FactureMultiple from './factureMultiple';

function MyAwesomeTable({
    rows,
    isLoading,
    onDelete,
    setIds,
    viewSortie,
    clients,
    setAdds,
    printBl,
    setIsSave,
    setMsg,
    setShowFilterModals,
    setMsgravity,
    actualise,
    setActualise
}) {
    window.moment = moment;
    const [selected, setSelected] = useState(new Set());
    const [gridRef, setGridRef] = useState(null);
    const [showFact, setShowFact] = useState(false);
    const [filterDate, setFilterDate] = useState({});

    function numberformat(data) {
        return new Intl.NumberFormat().format(data);
    }
    const filterValue = [
        { name: 'numbon', operator: 'contains', type: 'string', value: '' },
        { name: 'client', operator: 'inlist', type: 'select', value: [] },
        { name: 'datesort', operator: 'inrange', type: 'date', value: '' },
        { name: 'demand_par', operator: 'contains', type: 'string', value: '' },
        { name: 'engin', operator: 'contains', type: 'string', value: '' },
        { name: 'user', operator: 'contains', type: 'string', value: '' },
        { name: 'useru', operator: 'contains', type: 'string', value: '' },
        { name: 'nocommande', operator: 'contains', type: 'string', value: '' },
        { name: 'nofact', operator: 'contains', type: 'string', value: '' },
        { name: 'sifacture', operator: 'contains', type: 'string', value: '' },
        { name: 'prix_ttc', operator: 'gte', type: 'number', value: 0 },
        { name: 'prix_ht', operator: 'gte', type: 'number', value: 0 },
        { name: 'prix_tva', operator: 'gte', type: 'number', value: 0 },
        { name: 'remise', operator: 'gte', type: 'number', value: 0 },
        { name: 'source', operator: 'contains', type: 'string', value: '' }
    ];

    const columnss = [
        {
            name: 'id',
            header: 'Id',
            defaultVisible: false,
            defaultWidth: 80,
            type: 'number'
        },
        {
            header: 'Action',
            defaultWidth: 100,
            type: 'string',
            render: ({ data }) => {
                return (
                    <div className="menudrops">
                        <ButtonGroup aria-label="Basic example">
                            {/* {data.inventaireid === null ? (
                                <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> Facturer ligne</Tooltip>}>
                                    {data.nofact === 'neant' && data.nofact != null ? (
                                        <a href="#/admin/sorties" onClick={(e) => setFacts(data.id)}>
                                            <CardChecklist color="#0dd1fd" size={25} />
                                        </a>
                                    ) : (
                                        <></>
                                    )}
                                </OverlayTrigger>
                            ) : (
                                <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Inventaire</Tooltip>}>
                                    <ListCheck color="blue" size={25} />
                                </OverlayTrigger>
                            )} */}
                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> Imprimer BL</Tooltip>}>
                                <a href="#/admin/ventes" onClick={() => printBl(data.id)}>
                                    <Printer color="#000" size={25} />
                                </a>
                            </OverlayTrigger>

                            {data.facture !== 'neant' ? (
                                data.nofact === 'neant' ? (
                                    <a href="#/admin/ventes" onClick={() => setIds(data.id)}>
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Modifier</Tooltip>}>
                                            <PencilFill size={25} color="green" />
                                        </OverlayTrigger>
                                    </a>
                                ) : (
                                    <PencilFill size={25} color="gray" />
                                )
                            ) : data.inventaireid === null ? (
                                <a href="#/admin/ventes" onClick={() => setIds(data.id)}>
                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Modifier</Tooltip>}>
                                        <PencilFill size={25} color="green" />
                                    </OverlayTrigger>
                                </a>
                            ) : (
                                <PencilFill size={25} color="gray" />
                            )}

                            {data.sifacture === 'A facturer' ? (
                                <a href="#/admin/ventes" onClick={() => onDelete(data.id)}>
                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Supprimer</Tooltip>}>
                                        <Trash color="red" size={25} />
                                    </OverlayTrigger>
                                </a>
                            ) : (
                                <Trash color="gray" size={25} />
                            )}
                        </ButtonGroup>
                    </div>
                );
            }
        },
        {
            name: 'numbon',
            header: 'N° bon',
            defaultWidth: 90,
            type: 'string',
            textAlign: 'center',
            render: ({ data }) => (
                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-disabled">Cliquer pour plus de détails</Tooltip>}>
                    <p id="light" onClick={() => viewSortie(data.id, 1)}>
                        {data.numbon}
                    </p>
                </OverlayTrigger>
            )
        },

        {
            name: 'sifacture',
            header: 'Statut',
            defaultWidth: 100,
            type: 'string',
            textAlign: 'center',
            render: ({ data }) => (
                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-disabled">Cliquer pour plus de détails</Tooltip>}>
                    <>
                        {data.sifacture === 'Facturer' ? (
                            <p id="successs">{data.sifacture}</p>
                        ) : data.sifacture === 'Proforma' ? (
                            <p id="warning">{data.sifacture}</p>
                        ) : (
                            <p id="success" onClick={(e) => setFacts(data.id)}>
                                {data.sifacture}
                            </p>
                        )}
                    </>
                </OverlayTrigger>
            )
        },
        {
            name: 'client',
            header: 'Clients',
            defaultWidth: 170,
            type: 'string',
            filterEditor: SelectFilter,
            filterEditorProps: {
                multiple: true,
                wrapMultiple: false,
                dataSource: clients.map((c) => {
                    return { id: c.raisonsocial, label: c.raisonsocial };
                })
            }
        },
        {
            name: 'datesort',
            header: 'Date sortie',
            defaultWidth: 200,
            type: 'date',
            dateFormat: 'DD-MM-YYYY',
            textAlign: 'center',
            filterEditor: DateFilter,
            filterEditorProps: (props, { index }) => {
                // for range and notinrange operators, the index is 1 for the after field
                return {
                    dateFormat: 'DD-MM-YYYY',
                    placeholder: index === 1 ? 'Date fin' : 'Date debut'
                };
            },
            render: ({ value, cellProps: { dateFormat } }) => moment(value).format(dateFormat)
        },
        {
            name: 'remise',
            header: 'Remise',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ value }) => numberformat(value)
        },
        {
            name: 'prix_ht',
            header: 'Mont. HT',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ value }) => numberformat(value)
        },
        {
            name: 'prix_tva',
            header: 'Mont. TVA',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ value }) => numberformat(value)
        },
        {
            name: 'prix_ttc',
            header: 'Mont. TTC',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ value }) => numberformat(value)
        },
        {
            name: 'source',
            header: 'Entitée',
            defaultWidth: 100,
            textAlign: 'center',
            type: 'number',
            render: ({ value }) => (
                <p id={value === 'Dépôt' ? 'successs' : 'warning'} style={{ color: value === 'Dépôt' ? 'white' : 'black' }}>
                    {value}
                </p>
            )
        },
        { name: 'noprof', header: 'N° proforma', defaultWidth: 130, type: 'string' },
        { name: 'nofact', header: 'N° facture', defaultWidth: 130, type: 'string' },
        { name: 'nocommande', header: 'N° commande', defaultWidth: 130, type: 'string' },
        {
            name: 'demand_par',
            header: 'Demandeur',
            defaultWidth: 120,
            type: 'string'
        },
        { name: 'engin', header: 'Engin', defaultWidth: 130, type: 'string' },
        { name: 'user', header: 'Crée par', defaultWidth: 100, type: 'string' },
        {
            name: 'created_at',
            header: 'Crée le',
            defaultWidth: 130,
            type: 'string',
            render: ({ value }) => dateformat(value, 'dd-mm-yyyy HH:MM')
        },
        { name: 'useru', header: 'Modif. par', defaultWidth: 100, type: 'string' },
        {
            name: 'updated_at',
            header: 'Modif. le',
            defaultWidth: 130,
            type: 'string',
            render: ({ value }) => dateformat(value, 'dd-mm-yyyy HH:MM')
        }
    ];

    const setFacts = (id) => {
        if (id !== 0) {
            setSelected(id);
        }
        setShowFact(true);
    };

    const gridStyle = { minHeight: window.screen.height - 200 };

    // const onSelectionChange = useCallback(({ selected }) => {
    //     console.log(selected);
    //     setSelected(selected);
    // }, []);

    // const HandleonSelectionChange = ({ selected: newSelectedIds }) => {
    //     setSelected(newSelectedIds);
    // };

    function GetSortOrder(prop) {
        return function (a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        };
    }

    const exportCSV = async () => {
        //--------------- EXPORT VERS EXCEL ------------------
        const raw_data = gridRef.current.data.sort(GetSortOrder('datesort'));

        const rows = [];
        var realqte = 0;
        var qteprix = 0;
        raw_data.map((row, index) => {
            const totalBrut = row.lignesort.reduce((acc, item) => acc + (item.pivot.prix * (item.pivot.quantite-item.pivot.quantiteretour)), 0);
            
            row.lignesort.map((lsort) => {
                // realqte = lsort.pivot.quantite - lsort.pivot.quantiteretour;
                // let prixachat = lsort.pivot.prix_achat;
                var prixachat = lsort.pivot.prix_achat;

                realqte = lsort.pivot.quantite - lsort.pivot.quantiteretour;
                qteprix = lsort.pivot.prix * realqte;
                var remise = qteprix * (lsort.pivot.remise / 100);
                // remise += row.remise_main > 0 ? (row.type_remise > 0 ? row.remise_main : (qteprix - remise) * (row.remise_main / 100)) : 0;

                
                let remiseFixe = 0;

                if (row.remise_main > 0) {
                    if (row.type_remise == 0) {
                        // Cas 1 : Remise en % (row.remise_main vaut par exemple 5 pour 5%)
                        remiseFixe = qteprix * (row.remise_main / 100);
                    } else if (row.type_remise == 1) {
                        // Cas 2 : Remise en montant fixe répartie au prorata de la valeur de la ligne
                        if (row.lignesort.length === 1) {
                            remiseFixe = row.remise_main;
                        } else {
                            // Prorata : (Valeur Ligne / Valeur Totale Brute) * Montant Remise Globale
                            // Note : row.prix_ttc + row.remise représente bien le total brut avant remise
                            // const totalBrut = row.prix_ttc + row.remise;
                            remiseFixe = totalBrut > 0 ? (qteprix / totalBrut) * row.remise_main : 0;
                        }
                    }
                }
                let prixremiser = qteprix - remise - remiseFixe;

                rows.push({
                    numbon: row.numbon,
                    client: row.client,
                    qrbarre: lsort.qrbarre,
                    description: lsort.descriptionart,
                    engin: lsort.famille ? lsort.famille.libellefam + ' / ' + row.engin : row.engin,
                    retour: realqte,
                    prixachat: common.societe < 2 ? prixachat : 0,
                    tachat: common.societe < 2 ? Math.round(prixachat * realqte) : 0, //
                    remise: remise+remiseFixe, //
                    prixvente: lsort.pivot.prix,
                    tvente: Math.round(qteprix), //
                    prixremiser: prixremiser, //
                    tva: row.sitva == 1 ? 0 : prixremiser * 0.18, //
                    benefice: common.societe < 2 ? prixremiser - (realqte * prixachat) : 0,
                    date: dateformat(row.datesort, 'dd-mm-yyyy')
                });
            });
        });

        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Mes sorties');
        /* fix headers */
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [
                [
                    'N° bon',
                    'Clients',
                    'Code',
                    'Articles',
                    'Engin',
                    'Qté',
                    'Prix achat',
                    'Total achat',
                    'Remise',
                    'Prix vente',
                    'Total vente',
                    'Total remisé',
                    'TVA',
                    'Benefice',
                    'Date sortie'
                ]
            ],
            {
                origin: 'A1'
            }
        );
        /* calculate column width */
        const max_width = rows.reduce((w, r) => Math.max(w, r.numbon.length), 10);
        worksheet['!cols'] = [{ wch: max_width }];
        XLSX.writeFile(workbook, 'sortie.xlsx');
    };

    const exportCSVModel = async () => {
        //--------------- EXPORT VERS EXCEL ------------------
        const raw_data = gridRef.current.data.sort(GetSortOrder('datesort'));
        /* flatten objects */

        const rows = [];
        var realqte = 0;
        var qteprix = 0;
        raw_data.map((row, index) => {
            const totalBrut = row.lignesort.reduce((acc, item) => acc + (item.pivot.prix * (item.pivot.quantite-item.pivot.quantiteretour)), 0);
            
            row.lignesort.map((lsort) => {
                // realqte = lsort.pivot.quantite - lsort.pivot.quantiteretour;
                // let prixachat = lsort.pivot.prix_achat;
                var prixachat = lsort.pivot.prix_achat !== 0 ? lsort.pivot.prix_achat : lsort.prixachat;

                realqte = lsort.pivot.quantite - lsort.pivot.quantiteretour;
                qteprix = lsort.pivot.prix * realqte;
                var remise = qteprix * (lsort.pivot.remise / 100);
                // remise += row.remise_main > 0 ? (row.type_remise > 0 ? row.remise_main : (qteprix - remise) * (row.remise_main / 100)) : 0;

                
                let remiseFixe = 0;

                if (row.remise_main > 0) {
                    if (row.type_remise == 0) {
                        // Cas 1 : Remise en % (row.remise_main vaut par exemple 5 pour 5%)
                        remiseFixe = qteprix * (row.remise_main / 100);
                    } else if (row.type_remise == 1) {
                        // Cas 2 : Remise en montant fixe répartie au prorata de la valeur de la ligne
                        if (row.lignesort.length === 1) {
                            remiseFixe = row.remise_main;
                        } else {
                            // Prorata : (Valeur Ligne / Valeur Totale Brute) * Montant Remise Globale
                            // Note : row.prix_ttc + row.remise représente bien le total brut avant remise
                            // const totalBrut = row.prix_ttc + row.remise;
                            remiseFixe = totalBrut > 0 ? (qteprix / totalBrut) * row.remise_main : 0;
                        }
                    }
                }
                let prixremiser = qteprix - remise - remiseFixe;
                rows.push({
                    numbon: row.numbon,
                    client: row.client,
                    qrbarre: lsort.qrbarre,
                    description: lsort.descriptionart,
                    engin: lsort.famille ? lsort.famille.libellefam + ' / ' + row.engin : row.engin,
                    retour: realqte,
                    prixachat: common.societe < 2 ? prixachat : 0,
                    tachat: common.societe < 2 ? prixachat * realqte : 0, //
                    remise: Math.round(remise+remiseFixe), //
                    prixvente: lsort.pivot.prix,
                    tvente: qteprix, //
                    prixremiser: prixremiser, //
                    tva: row.sitva == 1 ? 0 : prixremiser * 0.18, //
                    benefice: qteprix - remise - remiseFixe - realqte * prixachat,
                    date: dateformat(row.datesort, 'dd-mm-yyyy')
                });
            });
        });

        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Mes sorties');
        /* fix headers */
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [
                [
                    'N° bon',
                    'Clients',
                    'Code',
                    'Articles',
                    'Engin',
                    'Qté',
                    'Prix achat',
                    'Total achat',
                    'Remise',
                    'Prix vente U',
                    'Prix vente',
                    'Total remisé',
                    'TVA',
                    'Benefice',
                    'Date sortie'
                ]
            ],
            {
                origin: 'A1'
            }
        );
        /* calculate column width */
        const max_width = rows.reduce((w, r) => Math.max(w, r.numbon.length), 10);
        worksheet['!cols'] = [{ wch: max_width }];
        XLSX.writeFile(workbook, 'sortie.xlsx');
    };
    //-------------IMPRIMER LES LISTE ----------------
    function printListeSelect() {
        if (window.confirm('Voulez-vous la version détaillée ?') === true) {
            printListeDetail();
        } else {
            printListe();
        }
    }
 


    function printListe() {
        const gridData = gridRef.current?.data || [];

        if (gridData.length <= 0) {
            setMsg('Aucune donnée à imprimer');
            setIsSave(true);
            setMsgravity('danger');
            return;
        }

        const doc = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: 'a4',
            putOnlyUsedFonts: true
        });

        const width = doc.internal.pageSize.getWidth();
        
        // Formateur réutilisable pour la monnaie (Format type FCFA)
        const formatXOF = (valeur) => 
            new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'XOF' }).format(valeur);

        // Gestion du titre de l'entreprise
        doc.setFontSize(16);
        const isDepotApi = ['https://192.168.8.109:81', 'https://api.tracky-entrepot.com'].includes(common.ipapi);
        doc.text(isDepotApi ? 'DEPOT' : 'HR MOTORS', 90, 14);

        // Rectangle d'en-tête
        doc.setFontSize(12);
        doc.setFillColor(0, 0, 0);
        doc.rect(65, 15, width - 80, 10, 'F');
        doc.setTextColor(255, 255, 255);
        doc.text('LISTE DES LIVRAISONS CLIENTS', 90, 22);

        doc.setTextColor(0, 0, 0);

        let totalHT = 0;
        let totalTva = 0;
        let totalTTC = 0;
        const bodyData = [];

        // Construction des lignes de données (6 colonnes pour correspondre au 'head')
        gridData.forEach((row) => {
            totalHT += row.prix_ht || 0;
            totalTva += row.prix_tva || 0;
            totalTTC += row.prix_ttc || 0;

            bodyData.push([
                { content: row.client || '' },
                { content: row.numbon || '' },
                { content: row.datesort ? dateformat(row.datesort, 'dd-mm-yyyy') : '' },
                { content: formatXOF(row.prix_ht) },
                { content: formatXOF(row.prix_tva) },
                { content: formatXOF(row.prix_ttc) }
            ]);
        });

        // Ajout de la ligne du TOTAL (Alignée sur les 6 colonnes)
        bodyData.push([
            { content: 'TOTAL', colSpan: 3, styles: { fontStyle: 'bold', fontSize: 12, halign: 'left' } },
            { content: formatXOF(totalHT), styles: { fontStyle: 'bold', fontSize: 12 } },
            { content: formatXOF(totalTva), styles: { fontStyle: 'bold', fontSize: 12 } },
            { content: formatXOF(totalTTC), styles: { fontStyle: 'bold', fontSize: 12 } }
        ]);

        // Génération du tableau avec autoTable
        doc.autoTable({
            theme: 'grid',
            startY: 35,
            styles: {
                fillColor: [169, 234, 254],
                textColor: [0, 0, 0],
                halign: 'center',
                fontSize: 8,
                cellPadding: 1
            },
            columnStyles: {
                0: { halign: 'left', fillColor: [255, 255, 255], fontSize: 8 },
                1: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 },
                2: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 },
                3: { halign: 'right', fillColor: [255, 255, 255], fontSize: 8 }, // Aligné à droite pour les chiffres
                4: { halign: 'right', fillColor: [255, 255, 255], fontSize: 8 },
                5: { halign: 'right', fillColor: [255, 255, 255], fontSize: 8 }
            },
            head: [['Clients', 'N° BL', 'Date BL', 'Montant HT', 'Montant TVA', 'Montant TTC']],
            body: bodyData
        });

        // Numérotation des pages
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.text(`Page ${i} sur ${pageCount}`, width - 15, 200, { align: 'right' });
        }

        // Note de bas de page sous le tableau
        doc.setFontSize(8);
        doc.setTextColor(254, 0, 0);
        doc.text('* Aucun produit ne peut être retourné', 14, doc.lastAutoTable.finalY + 5);

        doc.save('listesortie.pdf');
    }

    function printListeDetail() {
        // 1. Guard Clause
        if (!gridRef.current?.data || gridRef.current.data.length <= 0) return;

        // 2. Initialisation du document PDF
        const doc = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: 'a4',
            putOnlyUsedFonts: true
        });
        
        const width = doc.internal.pageSize.getWidth();
        const societe = common.societe;
        const data = [];

        // Helper unique pour le formatage des montants / quantités 
        const formatNum = (num) => new Intl.NumberFormat(['ban', 'id']).format(Math.round(num)).replace('.', ' ');

        // 3. Gestion du Logo et En-tête
        doc.addImage(societe === 0 ? common.logo : common.logo1, 'png', 14, 10, 30, 30);
        doc.setFillColor(0, 0, 0);
        doc.rect(65, 15, width - 80, 10, 'F');
        doc.setFontSize(12);
        doc.setTextColor(255, 255, 255);
        doc.text('LISTE DES LIVRAISONS AVEC DETAILS', 90, 22);
        doc.setTextColor(0, 0, 0);

        // 4. Tri et extraction des dates limites
        const datavar = [...gridRef.current.data].sort(GetSortOrder('datesort'));
        const firstDate = dateformat(datavar[0].datesort, 'dd-mm-yyyy');
        const lastDate = dateformat(datavar[datavar.length - 1].datesort, 'dd-mm-yyyy');

        // 5. Accumulateurs pour les totaux finaux
        let totalAchat = 0, qteTotale = 0, totalRemise = 0, totalTva = 0, totalHT = 0;

        // 6. Construction du corps des données
        datavar.forEach((row, index) => {
            if (index === 0 || row.numbon !== datavar[index - 1].numbon) {
                data.push([
                    {
                        content: `Client: ${row.client} / BL N°: ${row.numbon} / Date: ${dateformat(row.datesort, 'dd-mm-yyyy')}`,
                        colSpan: societe < 2 ? 11 : 8,
                        styles: { fontStyle: 'bold', fontSize: 8, fillColor: [240, 240, 240] }
                    }
                ]);
            }
            const totalBrut = row.lignesort.reduce((acc, item) => acc + (item.pivot.prix * (item.pivot.quantite-item.pivot.quantiteretour)), 0);
            row.lignesort.forEach((lsort) => {
                const prixAchat = lsort.pivot.prix_achat || 0;
                const realQte = (lsort.pivot.quantite || 0) - (lsort.pivot.quantiteretour || 0);
                const qtePrix = (lsort.pivot.prix || 0) * realQte;
                let remiseFixe = 0;
                totalHT += qtePrix;
                if (row.remise_main > 0) {
                    if (row.type_remise == 0) {
                        // Cas 1 : Remise en % (row.remise_main vaut par exemple 5 pour 5%)
                        remiseFixe = qtePrix * (row.remise_main / 100);
                    } else if (row.type_remise == 1) {
                        // Cas 2 : Remise en montant fixe répartie au prorata de la valeur de la ligne
                        if (row.lignesort.length === 1) {
                            remiseFixe = row.remise_main;
                        } else {
                            // Prorata : (Valeur Ligne / Valeur Totale Brute) * Montant Remise Globale
                            // Note : row.prix_ttc + row.remise représente bien le total brut avant remise
                            // const totalBrut = row.prix_ttc + row.remise;
                            remiseFixe = totalBrut > 0 ? (qtePrix / totalBrut) * row.remise_main : 0;
                        }
                    }
                }

                const remise = qtePrix * ((lsort.pivot.remise || 0) / 100);
                const prixRemise = qtePrix - remise-remiseFixe;
                const tvaLigne = row.sitva == 1 ? 0 : prixRemise * 0.18;
                totalTva += tvaLigne;
                totalRemise += remise + remiseFixe;

                qteTotale += realQte;
                totalAchat += prixAchat * realQte;

                // Ajout des lignes dynamiques selon le type de société
                if (societe < 2) {
                    data.push([
                        lsort.qrbarre,
                        lsort.descriptionart,
                        formatNum(realQte),
                        formatNum(prixAchat),
                        formatNum(prixAchat * realQte),
                        formatNum(remise + remiseFixe),
                        formatNum(lsort.pivot.prix),
                        formatNum(qtePrix),
                        formatNum(prixRemise ),
                        formatNum(tvaLigne),
                        formatNum(qtePrix - remise - remiseFixe - (realQte * prixAchat)) // Bénéfice
                    ]);
                } else {
                    data.push([
                        lsort.qrbarre,
                        lsort.descriptionart,
                        formatNum(realQte),
                        formatNum(remise + remiseFixe),
                        formatNum(lsort.pivot.prix),
                        formatNum(qtePrix),
                        formatNum(prixRemise - remiseFixe),
                        formatNum(tvaLigne)
                    ]);
                }
            });
        });

        // 7. Écriture simplifiée et propre de la Période
        const startPeriod = filterDate.start || firstDate;
        const endPeriod = filterDate.end || lastDate;
        doc.text(`Période du: ${startPeriod} Au : ${endPeriod}`, 65, 32);

        // 8. Ligne des Totaux Généraux
        const totalRowStyles = { fontStyle: 'bold', fontSize: 10, fillColor: [220, 245, 255] };
        if (societe < 2) {
            data.push([
                { content: 'TOTAL GENERAL', styles: totalRowStyles },
                '',
                { content: formatNum(qteTotale), styles: totalRowStyles },
                '',
                { content: formatNum(totalAchat), styles: totalRowStyles },
                { content: formatNum(totalRemise), styles: totalRowStyles },
                '',
                { content: formatNum(totalHT), styles: totalRowStyles },
                { content: formatNum(totalHT-totalRemise), styles: totalRowStyles },
                { content: formatNum(totalTva), styles: totalRowStyles },
                { content: formatNum(totalHT-totalRemise - totalAchat), styles: totalRowStyles }
            ]);
        } else {
            data.push([
                { content: 'TOTAL GENERAL', styles: totalRowStyles },
                '',
                { content: formatNum(qteTotale), styles: totalRowStyles },
                { content: formatNum(totalRemise), styles: totalRowStyles },
                '',
                { content: formatNum(totalHT), styles: totalRowStyles },
                { content: formatNum(totalHT), styles: totalRowStyles },
                { content: formatNum(totalTva), styles: totalRowStyles }
            ]);
        }

        // 9. Génération de l'AutoTable
        doc.autoTable({
            theme: 'grid',
            startY: 35,
            styles: {
                fillColor: [169, 234, 254],
                textColor: [0, 0, 0],
                halign: 'center',
                fontSize: 8,
                cellPadding: 1
            },
            headStyles: { fillColor: [169, 234, 254], fontStyle: 'bold' },
            columnStyles: {
                0: { halign: 'center', fontSize: 7, fillColor: [255, 255, 255] },
                1: { halign: 'left', fontSize: 7, fillColor: [255, 255, 255] },
                2: { halign: 'center', fontSize: 7, fillColor: [255, 255, 255] },
                3: { halign: 'right', fontSize: 7, fillColor: [255, 255, 255] },
                4: { halign: 'right', fontSize: 7, fillColor: [255, 255, 255] },
                5: { halign: 'right', fontSize: 7, fillColor: [255, 255, 255] },
                6: { halign: 'right', fontSize: 7, fillColor: [255, 255, 255] },
                7: { halign: 'right', fontSize: 7, fillColor: [255, 255, 255] },
                8: { halign: 'right', fontSize: 7, fillColor: [255, 255, 255] },
                9: { halign: 'right', fontSize: 7, fillColor: [255, 255, 255] },
                10: { halign: 'right', fontSize: 7, fillColor: [255, 255, 255] }
            },
            head: societe < 2 ?
                 [['Code','Articles','Qté liv','Prix achat','Total achat','Remise', 'Prix vente','Total vente','Total remisé','TVA','Bénéfice']]
                : [['Code', 'Articles', 'Qté liv', 'Remise', 'Prix vente', 'Total vente', 'Total remisé', 'TVA']],
            body: data
        });

        // 10. Pied de page dynamique (Numérotation des pages)
        const pageCount = doc.internal.getNumberOfPages();
        for (let u = 1; u <= pageCount; u++) {
            doc.setPage(u);
            doc.setFontSize(9);
            doc.text(`Page ${u} sur ${pageCount}`, width - 15, doc.internal.pageSize.getHeight() - 10, null, null, 'right');
        }

        doc.save('Listesortie.pdf');
    }

    const onFilterValueChange = useCallback((filterValue) => {
        setFilterDate(filterValue[2].value);
    }, []);

    const HandleonSelectionChange = ({ selected }) => {
        setSelected(selected);
        // console.log('Sélection actuelle :', selected);
    };
    const toArray = (selected, dataMap) => {
        const keysObj = selected === true ? dataMap : selected;
        return Object.keys(keysObj).map((key) => Number(key));
    };
    const dataMap = gridRef && gridRef.current && gridRef.current.dataMap ? gridRef.current.dataMap : null;

    return (
        <div>
            {showFact !== false ? (
                <FactureMultiple
                    setShowFact={setShowFact}
                    show={showFact}
                    setIsSave={setIsSave}
                    setMsg={setMsg}
                    setMsgravity={setMsgravity}
                    selectedRows={JSON.stringify(toArray(selected, dataMap))}
                    actualise={actualise}
                    setActualise={setActualise}
                />
            ) : (
                <></>
            )}

            <NavMenu
                printListe={printListeSelect}
                selected={JSON.stringify(toArray(selected, dataMap))}
                setAdds={setAdds}
                exportCSV={exportCSV}
                setFacts={setFacts}
                setShowFilterModals={setShowFilterModals}
                // printListeModel={printListeModel}
                exportCSVModel={exportCSVModel}
            />
            <ReactDataGrid
                idProperty="id"
                handle={setGridRef}
                style={gridStyle}
                loading={isLoading}
                reorderColumns={false}
                pagination
                selected={selected}
                enableSelection
                multiSelect
                checkboxColumn
                onSelectionChange={HandleonSelectionChange}
                pageSizes={[200, 400, 600, 800, 1000, rows.length]}
                defaultLimit={400}
                showHoverRows={true}
                editable={true}
                showColumnMenuTool={false}
                defaultFilterValue={filterValue}
                onFilterValueChange={onFilterValueChange}
                columns={columnss}
                dataSource={rows}
            />
            {/* <p>Selected rows: {JSON.stringify(toArray(selected, dataMap))}.</p> */}
        </div>
    );
}

export default MyAwesomeTable;
